import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="py-12 border-t border-white/10 bg-bg" data-id="element-34">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-35">
        <div className="text-white font-bold uppercase tracking-wider text-sm" data-id="element-36">
          <Link to="/" data-id="element-37">PP Management & Consulting</Link>
        </div>
        <div className="flex items-center gap-6 text-muted text-sm" data-id="element-38">
          <Link to="/impressum" className="hover:text-white transition-colors" data-id="element-39">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-white transition-colors" data-id="element-40">
            Datenschutz
          </Link>
          <span data-id="element-41">© 2026 Alle Rechte vorbehalten.</span>
        </div>
      </div>
    </footer>;
}